/* Lilla Guldfågeln · start page (lg-home.js)
   The gold bird in the hero, the jewellery index with its metal switch, the showroom glue to LG3D.room,
   the gold price calculator for every [data-pricecalc] element (the sell page loads this file too) and the
   engraving demo with the christening mug.
   Plain ES2019, no build step. Each home section includes this file deferred, so it guards against running twice
   and boots every element by its data-lg-home attribute: bird, index, room, engrave, stands. */
(function(){
'use strict';
if (window.LGHome) return;

/* ---------- helpers ---------- */
const $ = (s, el) => (el || document).querySelector(s);
const $$ = (s, el) => Array.from((el || document).querySelectorAll(s));
const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
function fmt(n){ return new Intl.NumberFormat('sv-SE', {minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2}).format(n) + ' kr' }
const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
const FINE = matchMedia('(pointer: fine)').matches;
const store = {
  get(k){ try { return localStorage.getItem(k) } catch(e){ return null } },
  set(k, v){ try { localStorage.setItem(k, v) } catch(e){} }
};

/* ---------- product data (LG.products, see the data contract in BUILD-BRIEF) ----------
   lg.js builds LG from the page's islands (#lg-data, every script[data-lg-data]) and the cards' data-lg entries.
   This merges the same sources once more, keeping what LG already holds, right before the 3D engine is asked for
   anything, so the showroom and the gift tiles find their pieces whichever script ran first. */
function LGo(){ return window.LG || (window.LG = {}) }
function products(){ const L = LGo(); return L.products || (L.products = {}) }
const parse = (el, src) => { if (!el._lgData) { try { el._lgData = JSON.parse(src) || {} } catch(e){ el._lgData = {} } } return el._lgData };
function mergeIslands(){
  const P = products();
  $$('script#lg-data, script[data-lg-data]').forEach(s => {
    const d = parse(s, s.textContent).products || {};
    for (const h in d) if (!P[h]) P[h] = d[h];
  });
  $$('[data-lg]').forEach(c => { const p = parse(c, c.getAttribute('data-lg')); if (p.h && !P[p.h]) P[p.h] = p });
  return P;
}

// lg-card's data entries already carry the Swedish display name (its SV table) in t
const title = p => p.t || '';
// collection names (the prototype's COLS) and which collections are gifts, for the showroom label
const COLS = {
  'vara-favoriter':'Våra favoriter', guldarmband:'Guldarmband', silverarmband:'Silverarmband', guldhalsband:'Guldhalsband',
  silverhalsband:'Silverhalsband', guldringar:'Guldringar', silverringar:'Silverringar', guldorhange:'Guldörhängen',
  silverorhangen:'Silverörhängen', guldberlock:'Guldberlocker', silverberlock:'Silverberlocker', bestick:'Bestick', muggar:'Muggar',
  flaggor:'Flaggor & flaggstänger', fotoalbum:'Fotoalbum', termos:'Termos', tallrikar:'Tallrikar', klockor:'Klockor'
};
const GIFT = ['bestick','muggar','flaggor','fotoalbum','termos','tallrikar'];
// the hallmark: lg-card's own (hm), else the metal, else 925 when the listed facts (lg-facts.json, through LG3D.data)
// say a gift is sterling silver
let FX = {};
const hallmark = p => p.hm || p.m || (/925/.test((FX[p.h] || {}).material || '') ? 'silver' : null);

/* ---------- the 3D engine (lg-3d.js), loaded when it is first needed ----------
   The layout may already include it; otherwise it is added here once, when a 3D part of the page comes near the
   viewport (each 3D section names the file in data-lg3d). The engine loads three.js and the blueprints itself. */
function addScript(src, test, ready){
  return new Promise((res, rej) => {
    if (ready()) { res(); return }
    let s = Array.from(document.scripts).find(x => x.src && test.test(x.src)), n = 0, t = 0;
    const done = ok => { clearInterval(t); if (ok) res(); else rej(new Error('3D unavailable')) };
    if (!s) {
      if (!src) { done(false); return }
      s = document.createElement('script'); s.src = src; s.async = false; document.head.appendChild(s);
    }
    s.addEventListener('load', () => { if (ready()) done(true) });
    s.addEventListener('error', () => done(false));
    t = setInterval(() => { if (ready()) done(true); else if (++n > 80) done(false) }, 250);   // a tag that ran before we listened
  });
}
let ENGINE = null;
function load3D(){
  if (ENGINE) return ENGINE;
  const own = $('[data-lg3d]');
  ENGINE = addScript(own && own.getAttribute('data-lg3d'), /lg-3d\.js/, () => !!window.LG3D)
    .then(() => { mergeIslands(); return window.LG3D });
  return ENGINE;
}
// runs cb once el comes within reach of the viewport (the 3D is lazy)
function onNear(el, cb, margin){
  if (!('IntersectionObserver' in window)) { cb(); return }
  const io = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) { io.disconnect(); cb() } }, {rootMargin: margin || '600px 0px'});
  io.observe(el);
}
/* card studio renders: LG3D.hydrate finds the .stand[data-h] elements in root and renders the ones that are seen;
   without 3D every stand keeps its photo (.nostudio) */
function hydrate(root){
  if (!$('.stand[data-h]', root)) return;
  onNear(root, () => load3D().then(L3 => { mergeIslands(); L3.hydrate(root) }).catch(() => {
    $$('.stand[data-h]', root).forEach(el => el.classList.add('nostudio'));
  }));
}

/* ---------- the gold bird ----------
   The logo is sampled into gold shards that fly in from the left, drift, scatter from the pointer and burst on a click;
   a light sweep runs over them. */
function initBird(box){
  const cv = $('canvas', box), fb = $('.fallback', box), ctx = cv && cv.getContext && cv.getContext('2d'), img = new Image();
  const fail = () => { if (cv) cv.hidden = true; if (fb) fb.hidden = false };
  if (!ctx) { fail(); return }
  let W = 0, H = 0, dpr = 1, parts = [], mouse = {x: -9999, y: -9999}, t0 = 0, running = false, visible = true, built = false;
  img.crossOrigin = 'anonymous';   // the theme's assets come from Shopify's CDN; reading the pixels needs CORS
  img.onerror = fail;
  img.onload = () => { build(true); start() };
  img.src = cv.getAttribute('data-src');
  function build(fly){
    const rect = cv.getBoundingClientRect(); W = Math.round(rect.width); H = Math.round(W * 424 / 546); if (!W) return;
    dpr = Math.min(2, window.devicePixelRatio || 1); cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const off = document.createElement('canvas'); off.width = W; off.height = H; const o = off.getContext('2d'); o.drawImage(img, W * .08, H * .05, W * .88, H * .88);   // inset, so particles never touch the canvas edge
    let d; try { d = o.getImageData(0, 0, W, H).data } catch(e){ fail(); return }
    const step = Math.max(3, Math.round(W / 120)); parts = [];
    for (let y = 0; y < H; y += step) for (let x = 0; x < W; x += step) {
      const i = (y * W + x) * 4; if (d[i + 3] < 140) continue;
      const jx = x + (Math.random() - .5) * step * .6, jy = y + (Math.random() - .5) * step * .6;
      const p = {tx: jx, ty: jy, r: d[i], g: d[i + 1], b: d[i + 2], s: step * (.75 + Math.random() * .7), a: Math.random() * Math.PI * 2, spin: (Math.random() - .5) * .02, vx: 0, vy: 0, ph: Math.random() * 6.28};
      if (fly && !REDUCED) { p.x = -W * .15 - Math.random() * W * .5; p.y = jy + (Math.random() - .5) * H * .9; p.delay = (1 - jx / W) * .15 + Math.random() * .55 }
      else { p.x = jx; p.y = jy; p.delay = 0 }
      parts.push(p);
    }
    built = true; if (REDUCED) draw(0);
  }
  function start(){ if (REDUCED || running) return; running = true; t0 = performance.now(); requestAnimationFrame(loop) }
  function loop(now){
    if (!visible || !cv.isConnected) { running = false; return }
    draw((now - t0) / 1000); requestAnimationFrame(loop);
  }
  function draw(t){
    ctx.clearRect(0, 0, W, H);
    const sweep = ((t % 6) / 6) * (W + H) * 1.6 - H * .4;
    for (const p of parts) {
      if (t > p.delay) {
        const bx = p.tx + Math.sin(t * 1.3 + p.ph) * .8, by = p.ty + Math.cos(t * 1.1 + p.ph) * .8;
        let ax = (bx - p.x) * .055, ay = (by - p.y) * .055;
        const dx = p.x - mouse.x, dy = p.y - mouse.y, d2 = dx * dx + dy * dy, R = W * .14;
        if (d2 < R * R) { const d = Math.sqrt(d2) || 1, f = (1 - d / R) * 5; ax += dx / d * f; ay += dy / d * f; p.a += .2 }
        p.vx = (p.vx + ax) * .84; p.vy = (p.vy + ay) * .84; p.x += p.vx; p.y += p.vy;
      }
      p.a += p.spin;
      const sd = (p.x + p.y * .7) - sweep, glow = Math.max(0, 1 - Math.abs(sd) / 38);
      const r = p.r + (255 - p.r) * glow, g = p.g + (250 - p.g) * glow, b = p.b + (225 - p.b) * glow;
      ctx.fillStyle = `rgb(${r | 0},${g | 0},${b | 0})`;
      const c = Math.cos(p.a) * p.s * .62, s = Math.sin(p.a) * p.s * .62;
      ctx.beginPath(); ctx.moveTo(p.x + c, p.y + s); ctx.lineTo(p.x - s * .9 - c * .4, p.y + c * .9 - s * .4); ctx.lineTo(p.x + s * .7 - c * .6, p.y - c * .7 - s * .6); ctx.closePath(); ctx.fill();
    }
  }
  const pos = e => { const r = cv.getBoundingClientRect(); return {x: e.clientX - r.left, y: e.clientY - r.top} };
  cv.addEventListener('pointermove', e => { mouse = pos(e) });
  cv.addEventListener('pointerleave', () => { mouse = {x: -9999, y: -9999} });
  cv.addEventListener('click', e => { const m = pos(e); for (const p of parts) { const dx = p.x - m.x, dy = p.y - m.y, d = Math.hypot(dx, dy) || 1; p.vx += dx / d * (16 + Math.random() * 14); p.vy += dy / d * (16 + Math.random() * 14) - 4; p.spin = (Math.random() - .5) * .25; setTimeout(() => { p.spin *= .08 }, 900) } });
  if ('IntersectionObserver' in window) new IntersectionObserver(es => { visible = es[0].isIntersecting; if (!visible) return; if (!built && img.complete && img.naturalWidth) build(true); if (built) start() }).observe(cv);
  let rt; window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(() => { if (img.complete && img.naturalWidth) { build(false); if (REDUCED) draw(0) } }, 200) });
}

/* ---------- jewellery index: first the metal, then the piece ----------
   The list for each metal is rendered by Liquid into <template data-ix-metal>; hovering a group shows its first piece
   on the plate as a studio render, cross-fading between two images. The chosen metal is remembered. */
// the plate's picture: the studio render (LG3D.studio); else the photo cut free of its white ground (LG3D.cutout),
// as the prototype fell back to cut/<handle>.png; else the shop's photo itself
function plateShot(h, photo){
  return load3D().then(L3 => L3.studio(h).then(u => ({u, cut: false}), () =>
    (typeof L3.cutout === 'function' ? L3.cutout(h) : Promise.reject(new Error('no cut-out'))).then(u => ({u, cut: true}))))
    .catch(() => ({u: photo, cut: true}));
}
function initIndex(sec){
  const list = $('.ixlist', sec), plate = $('.ixplate', sec), view = $('.ixview', sec);
  const A = $('#ixA', sec), B = $('#ixB', sec), st = $('#ixStamp', sec), nm = $('#ixName', sec), first = $('#ixFirst', sec);
  if (!list || !plate || !A || !B) return;
  let metal = store.get('lg-metal') === 'silver' ? 'silver' : 'guld', flip = false, cur = null, near = false;
  function showIx(g){
    const a = $(`.ix[data-g="${g}"]`, list); if (!a) return;
    const d = a.dataset;
    $$('.ix', list).forEach(x => x.classList.toggle('on', x === a));
    nm.textContent = d.name;
    first.textContent = d.first ? `${d.c} st · från ${d.from}` : `${d.c} st`;
    st.textContent = metal === 'guld' ? '750' : '925'; st.className = 'stamp' + (metal === 'guld' ? '' : ' ag');
    // the plate is drawn only once the index is near, and never while it is hidden (phones show thumbnails instead)
    if (!near || !d.first || d.first === cur || getComputedStyle(view).display === 'none') return;
    const h = cur = d.first;
    const swap = (src, isCut) => { if (cur !== h || !src) return;
      const [inn, out] = flip ? [A, B] : [B, A]; flip = !flip;
      inn.style.objectFit = 'contain'; inn.style.padding = isCut ? '18%' : '0'; inn.style.opacity = '';
      inn.src = src; inn.classList.remove('out'); out.classList.add('out'); };
    // the pre-rendered studio picture when the product has one, else a live render
    (d.st ? Promise.resolve({u: d.st, cut: false}) : plateShot(h, d.img)).then(r => swap(r.u, r.cut));
  }
  function render(){
    sec.dataset.metal = metal;
    $$('.metal [data-metal]', sec).forEach(b => b.setAttribute('aria-pressed', b.dataset.metal === metal));
    const on = $('.ix.on', list), g = on ? on.dataset.g : 'armband', tpl = $(`template[data-ix-metal="${metal}"]`, sec);
    if (tpl && list.getAttribute('data-shown') !== metal) { list.innerHTML = tpl.innerHTML; list.setAttribute('data-shown', metal) }
    cur = null; showIx(g); hydrate(list);
  }
  function setMetal(m){ metal = m === 'silver' ? 'silver' : 'guld'; store.set('lg-metal', metal); render() }
  sec._setMetal = setMetal;
  $$('.metal [data-metal]', sec).forEach(b => b.addEventListener('click', () => setMetal(b.dataset.metal)));
  const pick = e => { const a = e.target.closest && e.target.closest('.ix'); if (a) showIx(a.dataset.g) };
  list.addEventListener('mouseover', pick);
  list.addEventListener('focusin', pick);
  render();
  onNear(sec, () => { near = true; const on = $('.ix.on', list); showIx(on ? on.dataset.g : 'armband') }, '200px 0px');
}
// the footer's Guldsmycken / Silversmycken links: lg.js stores the metal and announces it (lg:metal); the index follows
document.addEventListener('lg:metal', e => { const sec = $('[data-lg-home~="index"]'); if (sec && sec._setMetal) sec._setMetal(e.detail) });

/* ---------- the showroom: glue to LG3D.room ----------
   The engine builds the counter with its holders; this adds the holder buttons, the floating label over the piece in
   focus and the texts for touch screens. Without 3D the pieces are shown as cards. */
function initRoom(sec){
  const box = $('.room', sec), cv = box && $('canvas', box), holders = $('.holders', sec), help = $('[data-room-help]', sec);
  if (!box || !cv) return;
  let items = [];
  try { items = JSON.parse($('script[data-room-items]', sec).textContent) } catch(e){}
  const fallback = () => {
    if (sec._roomFallback) return; sec._roomFallback = true;
    cv.remove(); const hint = $('.hint', box); if (hint) hint.remove();
    const tpl = $('template[data-room-fallback]', sec);
    box.insertAdjacentHTML('beforeend', `<div class="fallback">${tpl ? tpl.innerHTML : ''}</div>`);
    hydrate(box);
  };
  onNear(box, () => load3D().then(L3 => {
    const P = mergeIslands(); items = items.filter(it => P[it.h]);
    if (!items.length) { fallback(); return }
    if (typeof L3.data === 'function') L3.data().then(d => { FX = (d && d.facts) || {} }, () => {});
    const label = document.createElement('a'); label.className = 'sr-label'; label.hidden = true;
    let room = null;
    // a piece in focus: its holder button is pressed and a label with name, hallmark and price floats above it
    const onFocus = g => {
      if (!room) return;
      $$('button', holders).forEach(b => b.setAttribute('aria-pressed', !!g && +b.dataset.room === g.userData.i));
      const p = g && products()[g.userData.h];
      if (!p) { label.hidden = true; return }
      label.href = p.url;
      const hm = hallmark(p), sub = hm === 'guld' ? 'Guld 750' : hm === 'silver' ? 'Silver 925' : esc(COLS[p.col] || '');
      label.innerHTML = `<b>${esc(title(p))}</b><span>${sub} · <span class="num">${esc(p.pf)}</span></span><em>${GIFT.indexOf(p.col) > -1 ? 'Visa presenten' : 'Visa smycket'} →</em>`;
      label.hidden = false; label.style.pointerEvents = room.pinned ? 'auto' : 'none';
    };
    // every frame: keep the label over its stand, inside the room
    const onFrame = () => {
      if (!room || label.hidden || !room.focus) return;
      const q = room.anchor(room.focus), hw = label.offsetWidth / 2 + 8, lh = label.offsetHeight + 8;
      label.style.left = Math.max(hw, Math.min(cv.clientWidth - hw, q.x)) + 'px'; label.style.top = Math.max(lh, q.y) + 'px';
    };
    // a click on a piece opens its product page (the engine's default, which uses the same url)
    return L3.room(cv, items, {onFocus, onFrame}).then(r => {
      room = sec._room = r;
      const list = r.items || items;   // the engine keeps the pieces it could place; the buttons follow its order
      box.appendChild(label);
      if (!FINE) {
        const hint = $('.hint', box);
        if (hint && hint.dataset.touch) hint.textContent = hint.dataset.touch;
        if (help && help.dataset.roomTouch) help.textContent = help.dataset.roomTouch;
      }
      holders.innerHTML = list.map((it, i) => `<button type="button" data-room="${i}" aria-pressed="false">${esc(it.n)}</button>`).join('');
      holders.addEventListener('click', e => {
        const b = e.target.closest('[data-room]'); if (!b) return;
        const g = room.groups.find(x => x.userData.i === +b.dataset.room); if (!g) return;
        room.setFocus(room.focus === g && room.pinned ? null : g, true);
      });
      // a phone screen is too narrow to read the whole counter: start close on the first piece once it stands on its
      // holder (the buttons switch pieces, a tap beside the pieces shows the whole counter)
      if (!FINE && cv.clientWidth < 560) {
        const first = room.groups.find(x => x.userData.i === 0) || room.groups[0], t0 = Date.now();
        const go = () => {
          if (!first || room.focus || room.dead) return;
          if (first.children.some(o => o.userData && o.userData.jewel) || Date.now() - t0 > 8000) room.setFocus(first, true);
          else setTimeout(go, 150);
        };
        go();
      }
    });
  }).catch(fallback));
}

/* ---------- buy price calculator ----------
   Every [data-pricecalc] element gets the calculator (the home band and the sell page). An empty element is filled
   with the markup below; one that already holds it is only wired up.
   The shop's payout factors stay in code only; the page shows the result, never the method. */
const KF = {9: 0.010249196141479098, 14: 0.015988745980707392, 18: 0.020498392282958196, 21: 0.023914790996784566};
const KSTAMP = {9: '375', 14: '585', 18: '750', 21: '875'};
// rates fetched 2026-10-10 as a last resort; the live rates replace them, and the last live rates are kept for the next visit
let RATE = {xau: 4195.60, usdsek: 9.9656, at: '2026-10-10T17:19:04Z', live: false};
try {
  const c = JSON.parse(store.get('lg-rate') || 'null');
  if (c && c.xau > 0 && c.usdsek > 0 && c.at && new Date(c.at) > new Date(RATE.at)) RATE = {xau: c.xau, usdsek: c.usdsek, at: c.at, live: false};
} catch(e){}
const perGram = k => RATE.xau * RATE.usdsek * KF[k];
async function refreshRates(){
  try {
    const [g, fx] = await Promise.all([
      fetch('https://api.gold-api.com/price/XAU').then(r => r.json()),
      fetch('https://open.er-api.com/v6/latest/USD').then(r => r.json())
    ]);
    if (g && g.price > 0 && fx && fx.rates && fx.rates.SEK > 0) {
      RATE = {xau: g.price, usdsek: fx.rates.SEK, at: g.updatedAt || new Date().toISOString(), live: true};
      store.set('lg-rate', JSON.stringify({xau: RATE.xau, usdsek: RATE.usdsek, at: RATE.at}));
      $$('[data-pricecalc]').forEach(c => c._update && c._update());
    }
  } catch(e){}
}
let rateTimer = 0;
function rates(){
  if (rateTimer || !$('[data-pricecalc]')) return;
  refreshRates(); rateTimer = setInterval(() => { if (!document.hidden) refreshRates() }, 60000);
}
const stamp24 = iso => new Intl.DateTimeFormat('sv-SE', {timeZone: 'Europe/Stockholm', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit'}).format(new Date(iso)).replace(/(\d{2}):(\d{2})/, 'kl. $1.$2');
let pcN = 0;
function priceCalc(el){
  if (!el || el._update) return;
  if (!el.id) el.id = 'pricecalc-' + (++pcN);
  if (!el.querySelector('[data-wn]')) el.innerHTML = `<div><span class="eyebrow">Priskalkylator</span><h3 style="margin-top:8px">Vad får du för ditt guld?</h3></div>
    <div><p class="fine" style="margin-bottom:10px">1. Vilken stämpel har guldet?</p>
      <div class="kar k4" role="group" aria-label="Välj karat">${[9, 14, 18, 21].map(k => `<button type="button" data-k="${k}" aria-pressed="${k === 18}"><b>${k} K</b><span>${KSTAMP[k]}</span></button>`).join('')}</div>
      <p class="fine" style="margin-top:8px">22 K och 24 K värderar vi i butiken.</p></div>
    <div class="wt"><label for="wn-${el.id}"><span>2. Hur mycket väger det?</span></label>
      <div class="row2"><input type="range" min="1" max="200" step="0.5" value="10" aria-label="Vikt i gram, reglage" data-wr><input type="number" id="wn-${el.id}" min="0.1" max="5000" step="0.1" value="10" aria-label="Vikt i gram" data-wn><span class="unit">gram</span></div></div>
    <div class="pc-out"><span class="lbl">Vi betalar dig</span><span class="big foil" data-out>0 kr</span><span class="per" data-per></span>
      <span class="sr" aria-live="polite" data-sr></span>
      <span class="pc-live"><span class="dot" data-livedot></span><span data-live></span></span></div>
    <div class="pc-promise"><b>Priset du ser är priset du får.</b><p>Många guldköpare lovar ett pris på nätet och bjuder lägre när du kommer dit. Vi betalar exakt det räknaren visar, på dagens kurs. I butiken kontrollerar vi bara att guldet är äkta och väger det.</p></div>`;
  const pressed = el.querySelector('.kar button[aria-pressed="true"]');
  let k = pressed ? +pressed.dataset.k : 18, shown = 0, raf = 0;
  const wr = el.querySelector('[data-wr]'), wn = el.querySelector('[data-wn]'), out = el.querySelector('[data-out]');
  const put = (sel, t) => { const n = el.querySelector(sel); if (n) n.textContent = t };
  el._update = () => {
    const w = Math.max(0, parseFloat(wn.value) || 0), pg = perGram(k), total = Math.floor(pg * w);
    put('[data-per]', `${fmt(Math.floor(pg * 100) / 100)} per gram ${k} K`);
    put('[data-sr]', `Vi betalar ${fmt(total)}`);
    put('[data-live]', RATE.live ? `Live-kurs · uppdaterad ${stamp24(RATE.at)}` : `Kurs från ${stamp24(RATE.at)}`);
    const dot = el.querySelector('[data-livedot]'); if (dot) dot.classList.toggle('open', RATE.live);
    cancelAnimationFrame(raf); const from = shown, t0 = performance.now();
    const step = t => { const q = REDUCED ? 1 : Math.min(1, (t - t0) / 500), e = 1 - Math.pow(1 - q, 3); shown = from + (total - from) * e; out.textContent = fmt(Math.round(shown)); if (q < 1) raf = requestAnimationFrame(step) };
    raf = requestAnimationFrame(step);
  };
  el.querySelectorAll('.kar button').forEach(b => b.addEventListener('click', () => { k = +b.dataset.k; el.querySelectorAll('.kar button').forEach(x => x.setAttribute('aria-pressed', x === b)); el._update() }));
  wr.addEventListener('input', () => { wn.value = wr.value; el._update() });
  wn.addEventListener('input', () => { wr.value = Math.min(200, parseFloat(wn.value) || 1); el._update() });
  el._update();
}

/* ---------- engraving demo with the mug ----------
   Name and date preview on the mug as you type, and the button's text and price follow. An empty field previews its
   example, which is never ordered. The button itself is a [data-add][data-eng-home] buy button: lg.js reads the typed
   text and style and adds the mug with the engraving (Gravyr, Gravyrstil) and the fee product when the shop has one. */
function initEngrave(sec){
  const etxt = $('.etxt', sec), eA = $('.etxt .a', sec), eB = $('.etxt .b', sec), name = $('#eName', sec), date = $('#eDate', sec), btn = $('[data-eng-home]', sec);
  if (!etxt || !eA || !eB || !name || !date) return;
  const fit = () => {
    const n = eA.textContent.length, m = eB.textContent.length;
    eA.style.setProperty('--fit', Math.min(1, (etxt.classList.contains('caps') ? 7 : 8) / Math.max(1, n)).toFixed(3));
    eB.style.setProperty('--fitb', Math.min(1, 16 / Math.max(1, m)).toFixed(3));
  };
  const label = () => {
    if (!btn) return;
    const typed = !!(name.value.trim() || date.value.trim());
    // the label and the price are separate, so on a phone the label wraps and the price stays in one piece (.btn-price)
    btn.innerHTML = `<span>${typed ? 'Lägg muggen med gravyr i varukorgen' : 'Lägg muggen i varukorgen'}</span> <span class="btn-price">· <span class="num">${esc(typed ? btn.dataset.pfEng : btn.dataset.pf)}</span></span>`;
  };
  const show = (el, inp) => { el.textContent = inp.value || inp.placeholder; fit(); label() };
  name.addEventListener('input', () => show(eA, name));
  date.addEventListener('input', () => show(eB, date));
  $$('[data-es]', sec).forEach(b => b.addEventListener('click', () => {
    $$('[data-es]', sec).forEach(x => x.setAttribute('aria-pressed', x === b));
    etxt.classList.toggle('caps', b.dataset.es === 'caps'); fit();
  }));
  fit(); label();
}

/* ---------- boot ---------- */
const INIT = {bird: initBird, index: initIndex, room: initRoom, engrave: initEngrave, stands: hydrate};
function boot(root){
  mergeIslands();
  $$('[data-lg-home]', root).forEach(el => {
    if (el._lgBooted) return; el._lgBooted = true;
    el.getAttribute('data-lg-home').split(/\s+/).forEach(k => { if (INIT[k]) { try { INIT[k](el) } catch(e){ console.error(e) } } });
  });
  $$('[data-pricecalc]', root).forEach(priceCalc);
  if (!FINE) $$('[data-touch]', root).forEach(e => { if (!e.closest('.room')) e.textContent = e.dataset.touch });
  rates();
}
window.LGHome = {boot, priceCalc, load3D};
let booted = false;
const go = () => { if (booted) return; booted = true; boot(document) };
// after every deferred script (lg.js builds LG) has run
if (document.readyState === 'complete') go(); else { document.addEventListener('DOMContentLoaded', go); window.addEventListener('load', go) }
// theme editor: a re-rendered section boots again; a removed showroom stops its renderer
document.addEventListener('shopify:section:load', e => boot(e.target));
document.addEventListener('shopify:section:unload', e => {
  $$('[data-lg-home~="room"]', e.target).forEach(s => { if (s._room && typeof s._room.dispose === 'function') s._room.dispose() });
});
})();
